import { defineStore } from 'pinia'
import { ElNotification } from 'element-plus'
import { constantRoutes, asyncRoutes, liteRoutes } from '@/router'
import { updateMapEngine, userPermission } from '@/api/auth'
// import { TVNotification } from '@/data/global'
import { app } from '@/main'
import i18n from '@/local/i18n'
import { getUser, updateUser } from '@/utils/auth'


// function filterAsyncRoutes(routes, permission) {
//   const res = []
//   routes.forEach(route => {
//       const tmp = { ...route }
//       if (!tmp.children) {
//           for (const v of permission) {
//               if (tmp.meta.bypass) {
//                   res.push(tmp)
//                   break
//               }
//               if (tmp.meta.permission === v) {
//                   res.push(tmp)
//                   break
//               }
//           }
//       } else if (tmp.children.length === 1) {
//           for (const v of permission) {
//               if (tmp.children[0].meta.bypass) {
//                   res.push(tmp)
//                   break
//               }
//               // if (tmp.children[0].meta.permission === v) {
//               if (tmp.children[0].meta.permission) {
//                 if (tmp.children[0].meta.permission.includes(v)) {
//                     res.push(tmp)
//                     break
//                 }
//               } else {
//                 res.push(tmp) //will add duplicates for only child with no permission 
//               }
//           }
//       // } else if (tmp.children.length === 1) {
//       //   const onlyChild = { ...tmp.children[0] };

//       //   // Inherit parent's path if child's path is not absolute
//       //   if (!onlyChild.path.startsWith('/')) {
//       //     onlyChild.path = `${tmp.path}/${onlyChild.path}`.replace(/\/+/g, '/'); // Normalize double slashes
//       //   }

//       //   for (const v of permission) {
//       //     if (
//       //       onlyChild.meta.bypass ||
//       //       !onlyChild.meta.permission ||
//       //       onlyChild.meta.permission.includes(v)
//       //     ) {
//       //       res.push(onlyChild); // ✅ Push corrected child
//       //       break;
//       //     }
//       //   }
//       } else if (tmp.children.length > 1) {
//           const data = []
//           for (const val of tmp.children) {
//               if (val.meta.bypass) {
//                   data.push(val)
//                   break
//               }
//               for (const v of permission) {
//                   // if (val.meta.permission === v) {
//                   if (val.meta.permission) {
//                     if (val.meta.permission.includes(v)) {
//                         data.push(val)
//                         break
//                     }
//                   } else {
//                     data.push(val)
//                     break
//                   }
//               }
//           }
//           if (data.length > 0) {
//               tmp.children = data
//               res.push(tmp)
//           }
//       }
//   })

//   return res
// }

function filterAsyncRoutes(routes, permission) {
  const res = []

  routes.forEach(route => {
    const tmp = { ...route }

    if (tmp.meta?.bypass) {
      res.push(tmp)
      return
    }

    // Check if route has permissions and validate
    const hasPermission = () => {
      if (!tmp.meta?.permission) return true
      return tmp.meta.permission.some(p => permission.includes(p))
    }

    if (tmp.children) {
      tmp.children = filterAsyncRoutes(tmp.children, permission)
      if (tmp.children.length > 0 && hasPermission()) {
        res.push(tmp)
      }
    } else if (hasPermission()) {
      res.push(tmp)
    }
  })

  return res
}


export const useAppStore = defineStore('app', {
  state: () => ({
    sidebar: localStorage.getItem("sidebarStatus") || true,
    device: 'desktop',
    mapType: localStorage.getItem("mapType") || 'OSM',
    shortcut: []
  }),
  actions: {
    toggleSideBar() {
      this.sidebar = !this.sidebar
      if (this.sidebar) {
        localStorage.setItem("sidebarStatus", "true")
      } else {
        localStorage.setItem("sidebarStatus", "false")
      }
    },
    closeSideBar() {
      localStorage.setItem("sidebarStatus", "false")
      this.sidebar = false
    },
    toggleDevice(val) {
      this.device = val
    },
    toggleMapType(val) {
      localStorage.setItem("mapType", val)
      this.mapType = val

      const userStr = localStorage.getItem("TrackVisionUser")
      let userId = ''

      try {
        const user = JSON.parse(userStr)
        userId = user?.id || ''
      } catch (e) {
        userId = ''
      }
      const osType = navigator.platform || 'unknown'
      const query = {
        userId: userId,
        platformType: 'trackvision',
        platform: 'trackvision',
        osType: osType,
        osVersion: '',
        deviceName: '',
        deviceBrand: '',
        deviceModel: '',
        macAddress: '',
        platformMode: 'web',
        mapEngine: val
      }
      updateMapEngine(query).catch(() => {})
    },
    updateShortcut(val) {
      this.shortcut = val
    }
  },
})

export const useBreadcrumbStore = defineStore('breadcrumb', {
  state: () => ({
    category: '',
    report: ''
  }),
  actions: {
    update(val) {
      this.category = val.category
      this.report = val.report
    }
  }
})

// export const usePermissionStore = defineStore('permission', {
//   state: () => ({
//     roles: 'admin',
//     routes: [],
//     isRoutesReady: false
//   }),
//   actions: {
//     async getPermission() {
//       let permission = []
//       await userPermission().then(res => {
//           permission = app.config.globalProperties.permissionsList = res.data.access.permissions
//           const mapType = res.data.access.mapEngineWeb || 'OSM'
//           localStorage.setItem('mapType', mapType)
//           if (res.data.access.passwordUpdateReminder) {
//             const { t } = i18n.global
//             TVNotification(t('please_update_your_password'), null, 'warning')
//           }
//       })
//       return permission
//     },
//     async generateRoutes(permissions) {
//       let accessedRoutes

//       accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)
//       this.routes = constantRoutes.concat(accessedRoutes)
//       return this.routes
//   }
//     // generateRoutes() {
//     //   this.routes = constantRoutes.concat(asyncRoutes)
//     //   return this.routes
//     // }
//   }
// })

export const usePermissionStore = defineStore('permission', {
  state: () => ({
    roles: 'admin',
    routes: [],
    isRoutesReady: false,
    hasShownPasswordReminder: false  // 👈 Add this
  }),
  actions: {
    mergeAccessToLocalUser(accessData) {
      const currentUser = getUser()
      if (!currentUser) return

      const updatedUser = {
        ...currentUser,
        username: accessData.username ?? currentUser.username,
        type: accessData.type ?? currentUser.type,
        mainUserId: accessData.mainUserId ?? currentUser.mainUserId,
        setting: {
          ...currentUser.setting,
          mapEngineWeb: accessData.mapEngineWeb ?? currentUser.setting?.mapEngineWeb,
          mapEngineMobile: accessData.mapEngineMobile ?? currentUser.setting?.mapEngineMobile,
        },
        access: accessData
      }

      updateUser(updatedUser)
    },
    async getPermission() {
      let permission = []
      await userPermission().then(res => {
        this.mergeAccessToLocalUser(res.data.access)
        permission = app.config.globalProperties.permissionsList = res.data.access.permissions
        const mapType = res.data.access.mapEngineWeb || 'OSM'
        localStorage.setItem('mapType', mapType)
        const currentPath = window.location.pathname
        const publicPaths = [
          '/safevision-intercom',
          '/video-player',
          '/sharableLink',
          '/sharableLiveVideoLink',
        ]
        const isPublicPath = publicPaths.some((p) => currentPath.includes(p))
        
        // ✅ Show reminder only once per page load
        //Stop display in intercom for mobile / public share pages
        if ((res.data.access.passwordUpdateReminder || res.data.access.passwordExpiryEnable) && !this.hasShownPasswordReminder && !isPublicPath ) {
          const { t } = i18n.global
          const link = `${window.location.origin}/user-settings/user-profile/`
          if(res.data.access.passwordExpiryEnable){
            ElNotification({
              title: t('warning'),
              message: `<div> 
              ${t('your_passord_will_expire_in')} ${res.data.access.passwordResetReminderRemainingDay} ${t('days_on')} ${res.data.access.passwordResetReminderDate}.
              ${t('please')} <a href="${link}" target="_blank" style="color:#409EFF; text-decoration:underline;">${t('update_')}</a> ${t('it_to_prevent_any_service_interruption')}.</div>`,
              type: 'warning',
              duration: 0,        // stays until user closes
              showClose: true,     // show the close (X) button
              dangerouslyUseHTMLString: true,
              
            })

            this.hasShownPasswordReminder = true
          } else {
            ElNotification({
              message: `<div> ${t('your_passord_has_not_been_updated_in_over')} ${res.data.access.passwordResetReminderDay} ${t('days')}.
              ${t('please')} <a href="${link}" target="_blank" style="color:#409EFF; text-decoration:underline;">${t('update_')}</a> ${t('it_to_keep_your_account_secure')}.</div>`, 
              type: 'warning',
              duration: 0,        // stays until user closes
              showClose: true,     // show the close (X) button
              dangerouslyUseHTMLString: true,
            })

            this.hasShownPasswordReminder = true
          }
        }
      })
      return permission
    },

    async generateRoutes(permissions) {
      const currentUser = getUser()
      const isAdmin = currentUser?.type === 'admin'

      let accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)

      accessedRoutes = accessedRoutes.filter(route => {
        if (route.meta?.adminOnly && !isAdmin) {
          return false
        }
        return true
      })

      this.routes = constantRoutes.concat(accessedRoutes)
      return this.routes
      // let accessedRoutes = filterAsyncRoutes(asyncRoutes, permissions)
      // this.routes = constantRoutes.concat(accessedRoutes)
      // return this.routes
    }
  }
})

export const usePermissionStoreLite = defineStore('permissionLite', {
  state: () => ({
    roles: 'admin',
    routes: [],
    isRoutesReady: false
  }),
  actions: {
    async generateRoutes() {
      this.routes = liteRoutes
      return this.routes
    }
  }
})

// export const useErrorStore = defineStore('error', {
//   state: () => ({
//     status: null,
//     code: null,
//     message: null,
//     path: null,
//   }),
//   actions: {
//     setError({ status, code, message, path }) {
//       this.status = status
//       this.code = code
//       this.message = message
//       this.path = path
//     },
//     clearError() {
//       this.status = null
//       this.code = null
//       this.message = null
//       this.path = null
//     }
//   }
// })

export const useAccidentStore = defineStore('accident', {
  state: () => ({
    selectedRow: null, // This will hold your accident data
  }),
  persist: true,
  actions: {
    setSelectedRow(row) {
      this.selectedRow = row
    },
    clearSelectedRow() {
      this.selectedRow = null
    },
  }
})
